export const getBaseSearchQuery = (query) => {
  const now = new Date();
  const day = String(now.getDate()).padStart(2, '0');
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const year = now.getFullYear();
  const dateStr = `${year}-${month}-${day}`;

  return {
    query: {
      bool: {
        must: {
          function_score: {
            query: {
              multi_match: {
                query,
                fields: ['title^500', 'excerpt', 'textContent'],
                fuzziness: 'AUTO',
                analyzer: 'synonyms_analyzer',
              },
            },
            functions: [
              {
                filter: {
                  terms: { contentTypeName: ['page', 'document'] },
                },
                exp: {
                  date: {
                    origin: dateStr,
                    offset: '7d',
                    scale: '21d',
                    decay: 0.9,
                  },
                },
              },
              {
                filter: { term: { contentTypeName: 'post' } },
                exp: {
                  date: {
                    origin: dateStr,
                    offset: '7d',
                    scale: '7d',
                    decay: 0.8,
                  },
                },
              },
            ],
          },
        },
      },
    },
    sort: [
      {
        _script: {
          script: `
            if (doc['contentTypeName'].value == 'page') {
              return 1
            } else if (doc['contentTypeName'].value == 'post') {
              return 2
            } else if (doc['contentTypeName'].value == 'majorproject') {
              return 3
            } else if (doc['contentTypeName'].value == 'document') {
              return 4
            }
            return 5
          `,
          type: 'number',
          order: 'asc',
        },
      },
      {
        _score: {
          order: 'desc',
        },
      },
    ],
  };
};
